import React, { useState, useRef, useEffect, ReactElement } from 'react';
import { LoadingLogo } from 'ps-shared-ui/v4/LoadingLogo';

import dynamicImport from './loadComponent';
import MFEErrorBoundary from './MFEErrorBoundary';

type MFEContainerProps = {
  name: string;
  mfeAttributes?: {
    [key: string]: string | boolean | number;
  };
  mfeProperties?: {
    [key: string]: object;
  };
};

const MFEContainer = (props: MFEContainerProps): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);
  const wcRef = useRef<JSX.IntrinsicElements['rls-report-library']>(null);

  useEffect(() => {
    setIsLoading(true);
    dynamicImport(props.name).then(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (props.mfeProperties)
      Object.entries(props.mfeProperties).forEach(([key, entry]) => {
        if (wcRef && wcRef.current) wcRef.current[key] = entry;
      });
  }, [wcRef.current, props.mfeProperties]);

  const showLoading = isLoading && !customElements.get('rls-report-library');

  return (
    <MFEErrorBoundary>
      {showLoading && <LoadingLogo className="rls-loading-logo" pf={true} />}
      <rls-report-library ref={wcRef} {...props.mfeAttributes}></rls-report-library>
    </MFEErrorBoundary>
  );
};

export default MFEContainer;
